
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage } from "../../../services/api";
import { hideAddAdminModal } from "./adminModalDispatcher";



export const addAdminRequest = (data, navigate) => {
  return async (dispatch) => {
    dispatch({ "type": "ADD_ADMIN_REQUEST" });
    try {
      if (data.image) {
        var uploadedImage = await uploadImage(
          ApiURLs.UPLOAD_IMAGE, "image",
          data.image,
          "admin"
        );
        console.log(`upload image function response ${JSON.stringify(uploadedImage)}`)
        data.image = uploadedImage.data.file.path
      }


      var adminResponse = (data.id) ? await updateData(data, `${ApiURLs.ADMIN}/${data.id}`) : await postData(data, ApiURLs.ADMIN);
      if (adminResponse.status === 1) {
        dispatch({ "type": "ADD_ADMIN_SUCCESS" });
        dispatch(hideAddAdminModal());
        dispatch(adminLisitingRequest());
      } else {
        dispatch({ "type": "ADD_ADMIN_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_ADMIN_FAILED" });

    }
  };
};




export const adminLisitingRequest = (page = 1, pageSize = 50,) => {

  return async (dispatch) => {

    const url = `${ApiURLs.ADMIN}?offset=${page}&limit=${pageSize}`;

    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_ADMIN_REQUEST" });
    try {
      var adminData = await fetchData(url);
      console.log(`response when we try to get admin  ${JSON.stringify(adminData)}`)
      if (adminData.status === 1) {
        dispatch({ "type": "GET_ADMIN_REQUEST_SUCCESS", "payload": adminData.data.result, "total": adminData.data.total });
      } else {
        dispatch({ "type": "GET_ADMIN_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_ADMIN_REQUEST_FAILED" });
      console.log(`error while try to get admin  ${error}`)
    }
  }
};



export const deleteAdmin = (id) => {
  return async (dispatch) => {

    dispatch({ "type": "DELETE_ADMIN_REQUEST" });
    try {


      var adminResponse = await deleteData(`${ApiURLs.ADMIN}/${id}`);
      if (adminResponse.status === 1) {
        dispatch({ "type": "ADD_ADMIN_SUCCESS" });
        dispatch(adminLisitingRequest());
      } else {
        dispatch({ "type": "ADD_ADMIN_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_ADMIN_FAILED" });

    }
  };
};


